import React from "react";
import {connect} from "react-redux";
import {Image, ImageBackground, Platform, StyleSheet, Text, TouchableOpacity, View} from "react-native";

export interface pictoProps{
    folder : "light";
    picto : string;
}

export interface pictoState{
    picto : string;
    folder : "light";
}

abstract class Picto<P extends pictoProps,S extends pictoState> extends React.Component<P,S>{
    constructor(props : P) {
        super(props);
        this.picto = props.picto;
        this.state = {
            picto : props.picto,
        }
        this.style = this.props.style || {};
    }

    componentDidMount() {
        this.setState({
            picto : this.props.picto,
        });
    }

    render() {
        const styles = StyleSheet.create({
            picto :{
                width : 40,
                height : 40,
            },
            container : {
                flex : 1,
                flexDirection : "row",
                margin : 10,
                 alignItems:"center",
                justifyContent:"center"
            },
            text : {
                fontSize:18,
                color : this.props.theme.colors.tertiary.black1.value
            },
            container_texte :{
                flex :1,
                alignItems: "flex-start",
                marginTop : 10,
                marginLeft : 5,
                textAlign : "left"
            },
            pictoBouton :{

                width : 15,
                height:15,
                margin:2.5,
                marginRight:5,
                marginTop : 2.5,
                //marginTop : Platform.select({ios : 4,android:2.5}),

            },
            containerBouton:{
                height:"100%"
            }
        });

        if(this.props.isHeader){
            return (
                <ImageBackground resizeMode={"contain"} style={[styles.picto,this.style]} source={(!this.props.isDark) ? this.picto.light : this.picto.dark} />
            );
        }

        if(this.props.isBouton){
            return (
                <View style={styles.containerBouton}><Image resizeMode={"contain"} style={[styles.pictoBouton,this.style]} source={(!this.props.isDark) ? this.picto.light : this.picto.dark} /></View>
            );
        }

        return (
            <View style={styles.container}>
                <TouchableOpacity><ImageBackground resizeMode={"contain"} style={styles.picto} source={(!this.props.isDark) ? this.picto.light : this.picto.dark} /></TouchableOpacity>
                <View style={styles.container_texte}>
                    <Text style={styles.text}>{this.picto.name.replace(' ','')}Picto</Text>
                </View>

            </View>
        );

    }
}

export default (Picto);

